import React, { useState } from 'react';
import './index.css';

const PayFees = () => {
  const [studentID, setStudentID] = useState('');
  const [student, setStudent] = useState(null);
  const [payment, setPayment] = useState(null);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [paidFees, setPaidFees] = useState(null);
  const [remainingFees, setRemainingFees] = useState(null);
  const [receiptNumber, setReceiptNumber] = useState("");
  const [amount, setAmount] = useState('');
  const [nextTermDate, setNextTermDate] = useState('');
  const [paymentMode, setPaymentMode] = useState('');
  const [paymentType, setPaymentType] = useState('');
  const [loading, setLoading] = useState(false);
  const api = process.env.REACT_APP_API;

  const handleInputChange = (e) => setStudentID(e.target.value);
  const handleReceiptNumberChange = (e) => setReceiptNumber(e.target.value);
  const handlePaymentModeChange = (e) => setPaymentMode(e.target.value);
  const handlePaymentTypeChange = (e) => {
    const type = e.target.value;
    setPaymentType(type);

    if (type === "Token") {
      setAmount(500);
      setNextTermDate('');
    } else if (type === "Full") {
      setAmount(remainingFees);
      setNextTermDate('');
    } else {
      setAmount('');
      const nextDue = new Date();
      nextDue.setDate(nextDue.getDate() + 20);
      setNextTermDate(nextDue.toISOString().split('T')[0]);
    }
  };
  const handleAmountChange = (e) => {
    if (paymentType !== "Installment") return;
    const val = Number(e.target.value);
    if (val > remainingFees) {
      alert("Installment amount cannot exceed remaining fees");
      return;
    }
    setAmount(val);
  };
  const handleNextTermDateChange = (e) => setNextTermDate(e.target.value);

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return `${date.toLocaleDateString()} at ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  };

  const center = localStorage.getItem("center");
  const token = localStorage.getItem("jwt_token");

  const handleButtonClick = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${api}/student/${studentID}`);
      if (!response.ok) {
        alert("Student not found");
        throw new Error('Student not found');
      }
      const data = await response.json();
      if (data.admission.centerName !== center) {
        alert("This Student Is Not From Your Center");
        throw new Error('Invalid center');
      }

      setStudent(data.admission);
      if (data.feesDetails) setPayment(data.feesDetails);

      const paid = data.feesDetails ? data.feesDetails.terms.reduce((sum, term) => sum + term.amountPaid, 0) : 0;
      const remaining = data.admission.totalFees - paid;
      setPaidFees(paid);
      setRemainingFees(remaining);
      setError(null);
    } catch (err) {
      setStudent(null);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePayFeesClick = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const handlePayButtonClick = async () => {
  if (!paymentType) return alert("Select payment type");
  if (!receiptNumber) return alert("Receipt number is required");
  if (!amount || isNaN(amount) || Number(amount) <= 0) return alert("Enter a valid amount");
  if (!paymentMode) return alert("Select payment mode");

  if (paymentType === "Installment" && !nextTermDate) {
    return alert("Next due date is required for installment");
  }

  // ✅ Conditionally include nextTermDate
  const paymentDetails = {
    IdNo: studentID.trim(),
    receiptNumber: receiptNumber.trim(),
    amountPaid: Number(amount),
    modeOfPayment: paymentMode,
    center,
    paymentType,
    ...(paymentType === "Installment" && { nextTermDate })
  };

  try {
    const response = await fetch(`${api}/pay-fees`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(paymentDetails),
    });

    if (!response.ok) {
      const errText = await response.text();
      console.error("Payment failed:", errText);
      throw new Error('Failed to process payment');
    }

    alert('Payment successful');
    setReceiptNumber('');
    setAmount('');
    setNextTermDate('');
    setPaymentMode('');
    setPaymentType('');
    closeModal();
    handleButtonClick(); // Refresh student data
  } catch (error) {
    console.error("Payment Error:", error.message);
    alert(error.message);
  }
};

  return (
    <div className="student-details-container">
      <div className="input-container">
        <input
          type="text"
          value={studentID}
          onChange={handleInputChange}
          placeholder="Enter Student ID"
          className="student-input"
        />
        <button onClick={handleButtonClick} className="search-button">Get Details</button>
      </div>

      {loading && <p className="loading-view">Loading...</p>}
      {error && !loading && <p className="error-message">{error}</p>}
      {!student && !loading && !error && <p className="initial-view">Enter the Student ID to get details</p>}

      {student && !loading && (
        <div className="student-card">
          <div className="student-info">
            <h2>{student.name}</h2>
            <p><strong>Course:</strong> {student.courseEnrolled}</p>
            <p><strong>Timings:</strong> {student.timings}</p>
            <p><strong>Start Date:</strong> {formatDate(student.dateOfJoining)}</p>
            <p><strong>Paid Fees:</strong> ₹{paidFees}</p>
            <p><strong>Remaining Fees:</strong> ₹{remainingFees}</p>
            <p><strong>Total Fees:</strong> ₹{student.totalFees}</p>
            {payment?.totalStatus === "completed" ? (
              <h3 style={{ color: "green" }}>Fees Paid</h3>
            ) : (
              <button onClick={handlePayFeesClick} className="pay-fees-button">Pay</button>
            )}
          </div>
        </div>
      )}

      {showModal && (
        <div className="pay-fee-modal-overlay">
          <div className="modal-content">
            <span className="close-modal" onClick={closeModal}>&times;</span>
            <h2>Pay Fees</h2>

            <div className="modal-input-container">
              <label>Payment Type</label>
              <select value={paymentType} onChange={handlePaymentTypeChange}>
                <option value="">Select</option>
                <option value="Token">Token</option>
                <option value="Installment">Installment</option>
                <option value="Full">Full Payment</option>
              </select>
            </div>

            <div className="modal-input-container">
              <label>Receipt Number</label>
              <input type="text" value={receiptNumber} onChange={handleReceiptNumberChange} />
            </div>

            <div className="modal-input-container">
              <label>Amount</label>
              <input
                type="number"
                value={amount}
                onChange={handleAmountChange}
                readOnly={paymentType === "Token" || paymentType === "Full"}
              />
            </div>

            {paymentType === "Installment" && (
              <div className="modal-input-container">
                <label>Next Term Date</label>
                <input
                  type="date"
                  value={nextTermDate}
                  onChange={handleNextTermDateChange}
                />
              </div>
            )}

            <div className="modal-input-container">
              <label>Mode of Payment</label>
              <select value={paymentMode} onChange={handlePaymentModeChange}>
                <option value="">Select</option>
                <option value="Cash">Cash</option>
                <option value="Credit Card">Credit Card</option>
                <option value="Debit Card">Debit Card</option>
                <option value="Bank Transfer">Bank Transfer</option>
                <option value="Online Payment">Online Payment</option>
              </select>
            </div>

            <button onClick={handlePayButtonClick} className="modal-pay-button">Pay</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PayFees;
